export function IntelNotSupported() {
  return (
    <div className='flex flex-col items-center gap-4 text-center'>
      <h2 className='text-2xl font-semibold text-[var(--color-text-primary)]'>
        Apple Silicon required
      </h2>
      <p className='max-w-md text-[var(--color-text-secondary)]'>
        Ahoy Desktop requires Apple Silicon. Intel Macs will not be supported –
        our recording technology is Apple Silicon only.
      </p>
    </div>
  );
}
